import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AdminHomeSliderService } from '../shared/service/admin-home-slider.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { FileUploadService } from './../shared/service/file-upload.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { environment } from 'src/environments/environment';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
import { Router } from '@angular/router';
import { CommonService } from '../shared/service/common.service';
import { HomeSlider } from '../shared/model/HomeSlider';
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';

@Component({
  selector: 'app-admin-home-slider',
  templateUrl: './admin-home-slider.component.html',
  styleUrls: ['./admin-home-slider.component.css']
})
export class AdminHomeSliderComponent implements OnInit {

  homeSliderArr = [];
  dataSource: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['TourType', 'Description', 'SliderImage', 'Edit', 'Delete'];
  LocalToken: string = '';
  imageBaseUrl: string = environment.imageBaseUrl;
  serviceBaseUrl: string = environment.serviceBaseUrl;
  imagePath: string;

  constructor(private adminHomeSlider: AdminHomeSliderService, private autoLogoutService: AutoLogoutService, private router: Router, private dialog: MatDialog) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();
  }

  ngOnInit() {
    this.imagePath = this.imageBaseUrl + "/KesaviDefault.jpg";
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getHomeSlider();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }
  }

  getHomeSlider() {
    this.adminHomeSlider
      .getHomeSlider()
      .then((result) => {
        this.homeSliderArr = result;
        this.dataSource = new MatTableDataSource(this.homeSliderArr);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
      .catch((err) => console.log(err));
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  deleteHomeSlider(ID) {
    if (this.homeSliderArr.length > 1) {
      if (confirm('Are you sure you want selected item deleted !')) {
        this.adminHomeSlider
          .deleteHomeSlider(ID)
          .then((result) => this.getHomeSlider())
          .catch((err) => console.log(err));
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(AdminHomeSliderDialog, {
      width: '1000px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getHomeSlider();
    });
  }

  editDialog(homeSliderObj) {
    const dialogRef = this.dialog.open(AdminHomeSliderDialog, {
      width: '1000px',
      data: JSON.parse(JSON.stringify(homeSliderObj))
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getHomeSlider();
    });
  }


}

// Dialoag Component

@Component({
  selector: 'admin-home-slider-dialog',
  templateUrl: 'admin-home-slider-dialog.html',
})
export class AdminHomeSliderDialog {

  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;
  fileListObj: FileList;

  constructor(public dialogRef: MatDialogRef<AdminHomeSliderDialog>,
    @Inject(MAT_DIALOG_DATA) public data: HomeSlider, private adminHomeSliderService: AdminHomeSliderService, private fileUploadService: FileUploadService, private commonService: CommonService) {
    if (this.data.Id) {
      this.isUpdate = true;
    }
  }

  addHomeSlider() {
    this.blockUI.start('Please wait...');
    if (this.fileListObj) {
      this.adminHomeSliderService
        .addHomeSlider(this.data)
        .then((result) => {
          let folderName = "HomeSlider\\" + result;
          this.fileUploadService.ImageUpload(this.fileListObj, folderName).then(() => {
            this.clearControl();
            this.blockUI.stop();
            this.dialogRef.close();
          })
            .catch((err) => this.errorHandler(err));
        })
    }
    else {
      this.adminHomeSliderService
        .addHomeSlider(this.data)
        .then((result) => {
          this.clearControl();
          this.blockUI.stop();
          this.dialogRef.close();
        })
        .catch((err) => this.errorHandler(err));
    }
  }

  editHomeSlider() {
    this.blockUI.start('Please wait...');
    if (this.fileListObj) {
      this.adminHomeSliderService
        .editHomeSlider(this.data)
        .then((result) => {
          let folderName = "HomeSlider\\" + result;
          this.fileUploadService.ImageUpload(this.fileListObj, folderName).then(() => {
            this.clearControl();
            this.blockUI.stop();
            this.dialogRef.close();
          })
            .catch((err) => this.errorHandler(err));
        })
    }
    else {
      this.adminHomeSliderService
        .editHomeSlider(this.data)
        .then((result) => {
          this.clearControl();
          this.blockUI.stop();
          this.dialogRef.close();
        })
        .catch((err) => this.errorHandler(err));
    }
  }

  public docChoose(fileInput: any, category: string) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.data.SliderImage = "";
      if (category == "SliderImage") {
        this.data.SliderImage = encodeURI(fileInput.target.files[0].name);
      }
    }
  }

  removeFile(event) {
    var itemtoRemove = event.target.outerText;
    if (itemtoRemove) {
      if (confirm("Image will deleted permenently. Are you sure?")) {
        if (this.data.Id) {
          this.data.SliderImage = null;
          let parentFolder = "HomeSlider"
          this.commonService
            .FileDelete(this.data.Id, itemtoRemove, parentFolder).then(() => {
              this.adminHomeSliderService
                .editHomeSlider(this.data)
                .then((result) => {
                  //console.log("FileDeleted ", + result);
                })
                .catch((err) => this.errorHandler(err));
            }).catch((err) => this.errorHandler(err));
        }
        else {
          this.data.SliderImage = null;
        }
      }
    }
  }

  fileChange(event, category) {
    this.docChoose(event, category);
    this.fileListObj = event.target.files;
  }


  clearControl() {
    this.data
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }

}
